export const colors = {
  amber: {
    50: "#fef7e9",
    100: "#fee6be",
    200: "#fdd796",
    300: "#fbc76f",
    400: "#f9b748",
    500: "#f7a823",
    600: "#df8e07",
    700: "#af6f04",
    800: "#7e5001",
    900: "#4d3000",
  },
  aqua: {
    50: "#e4f2fb",
    100: "#c9e8fb",
    200: "#9ed8fa",
    300: "#70c9fa",
    400: "#40b9f1",
    500: "#0099d4",
    600: "#0181b8",
    700: "#006394",
    800: "#004a75",
    900: "#003254",
  },
  blue: {
    50: "#e4f1fb",
    100: "#bae1fd",
    200: "#92cdf7",
    300: "#6db8ee",
    400: "#4ba3e2",
    500: "#3692d3",
    600: "#2c7fba",
    700: "#17649b",
    800: "#084977",
    900: "#002d4e",
  },
  cyan: {
    50: "#e4f9fb",
    100: "#baf6fd",
    200: "#92edf7",
    300: "#6de1ee",
    400: "#4bd3e2",
    500: "#36c3d3",
    600: "#2cacba",
    700: "#178e9b",
    800: "#086c77",
    900: "#00464e",
  },
  darkBlue: {
    50: "#e4eafb",
    100: "#baccfd",
    200: "#92adf7",
    300: "#6d8fee",
    400: "#4b73e2",
    500: "#3660d3",
    600: "#2c52ba",
    700: "#173a9b",
    800: "#082677",
    900: "#00154e",
  },
  darkOrange: {
    50: "#feede8",
    100: "#fecbbe",
    200: "#fdab96",
    300: "#fb8b6f",
    400: "#f96b48",
    500: "#f74d23",
    600: "#df3207",
    700: "#af2604",
    800: "#7e1a01",
    900: "#4d0f00",
  },
  darkPurple: {
    50: "#eee4fb",
    100: "#d6bafd",
    200: "#bc92f7",
    300: "#a36dee",
    400: "#8a4be2",
    500: "#7836d3",
    600: "#672cba",
    700: "#4e179b",
    800: "#370877",
    900: "#20004e",
  },
  gray: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#f0f0f0",
    300: "#d9d9d9",
    400: "#bfbfbf",
    500: "#8c8c8c",
    600: "#595959",
    700: "#434343",
    800: "#262626",
    900: "#1f1f1f",
  },
  grassGreen: {
    50: "#e8fbe4",
    100: "#c5fdba",
    200: "#a3f792",
    300: "#82ee6d",
    400: "#64e24b",
    500: "#50d336",
    600: "#43ba2c",
    700: "#2d9b17",
    800: "#1b7708",
    900: "#0d4e00",
  },
  green: {
    50: "#f3fbe4",
    100: "#e3fcb6",
    200: "#cef48b",
    300: "#b9e864",
    400: "#a1d643",
    500: "#86bc25",
    600: "#76aa1a",
    700: "#5a8809",
    800: "#517909",
    900: "#314d00",
  },
  lime: {
    50: "#f8fbe4",
    100: "#f4fcb6",
    200: "#e8f48b",
    300: "#d8e864",
    400: "#c5d643",
    500: "#aabc25",
    600: "#99aa1a",
    700: "#798809",
    800: "#6c7909",
    900: "#444d00",
  },
  magenta: {
    50: "#fce6f2",
    100: "#f9cee4",
    200: "#f39dc9",
    300: "#ec6baf",
    400: "#e63a94",
    500: "#e00979",
    600: "#be0867",
    700: "#9d0655",
    800: "#7b0543",
    900: "#5a0430",
  },
  orange: {
    50: "#ffefe0",
    100: "#fedcbe",
    200: "#fdc696",
    300: "#fbb06f",
    400: "#f99b48",
    500: "#f78623",
    600: "#df6c07",
    700: "#af5404",
    800: "#7e3c01",
    900: "#4d2400",
  },
  purple: {
    50: "#f7e4fb",
    100: "#efbafd",
    200: "#e392f7",
    300: "#d46dee",
    400: "#c44be2",
    500: "#b02fd0",
    600: "#9827b4",
    700: "#7c2093",
    800: "#5f1971",
    900: "#3d004d",
  },
  red: {
    50: "#fde8eb",
    100: "#febec4",
    200: "#fd96a0",
    300: "#fb6f7d",
    400: "#f9485a",
    500: "#f72338",
    600: "#df071c",
    700: "#af0415",
    800: "#7e010e",
    900: "#4d0008",
  },
  teal: {
    50: "#e4fbf9",
    100: "#bafdf7",
    200: "#92f7ee",
    300: "#6deee3",
    400: "#4be2d5",
    500: "#36d3c6",
    600: "#2cbaae",
    700: "#179b90",
    800: "#08776e",
    900: "#004e47",
  },
  terra: {
    "50-light": "#f2f1ee",
    50: "#e3e9ec",
    100: "#c5cacd",
    200: "#a5adb0",
    300: "#89959b",
    400: "#778389",
    500: "#6c767b",
    600: "#626a6e",
    700: "#485156",
    800: "#3a4145",
    900: "#2d373b",
  },
  turquoise: {
    50: "#e4fbf0",
    100: "#bafddb",
    200: "#92f7c4",
    300: "#6deead",
    400: "#4be296",
    500: "#36d385",
    600: "#2cba73",
    700: "#179b59",
    800: "#087740",
    900: "#004e27",
  },
  violet: {
    50: "#fbe4fb",
    100: "#fdbafb",
    200: "#f792f4",
    300: "#ee6deb",
    400: "#e24bde",
    500: "#b02fd0",
    600: "#b427b1",
    700: "#932091",
    800: "#71196f",
    900: "#4d004b",
  },
  yellow: {
    50: "#fefbe4",
    100: "#fff9c7",
    200: "#fff599",
    300: "#fff170",
    400: "#ffed4d",
    500: "#ffe602",
    600: "#e8d000",
    700: "#bfac00",
    800: "#948500",
    900: "#4d4500",
  },
} as const;
export default colors;
